import { MapPin, Gift } from "lucide-react";
import { Button } from "@/components/ui/button";
import { brl, imgUrl } from "@/lib/api";
import { openInfo, loyaltyText } from "@/lib/shop";
import { ShopBanner } from "./ShopBanner";

function LoyaltyCard({ l, me, onAccount, color }) {
  const bal = me?.loyalty;
  const pts = l.mode === "points";
  return (
    <div className="w-full rounded-2xl border border-slate-200 bg-white p-5 shadow-sm lg:w-[380px] lg:shrink-0" data-testid="shop-loyalty-card">
      <p className="flex items-center gap-2 font-bold"><Gift className="h-5 w-5" style={{ color }} />{pts ? "Troque pontos por recompensas" : "Ganhe cashback nas compras"}</p>
      <p className="mt-3 text-sm text-slate-600">{loyaltyText(l)}</p>
      {pts && l.rewards?.length > 0 && (
        <ul className="mt-3 space-y-1 text-sm" data-testid="shop-rewards-list">
          {l.rewards.slice(0, 4).map((r) => <li key={r.id} className="flex justify-between gap-2"><span className="truncate text-slate-700">{r.type === "product" ? `${r.name} grátis` : r.name}</span><span className="shrink-0 font-semibold" style={{ color }}>{r.points} pts</span></li>)}
        </ul>
      )}
      {bal ? (
        <p className="mt-3 rounded-lg px-3 py-2 text-sm font-semibold" style={{ background: `${color}14`, color }} data-testid="shop-loyalty-balance">
          Seu saldo: {pts ? `${bal.balance} pontos` : brl(bal.balance)}
        </p>
      ) : (
        <Button variant="outline" size="sm" className="mt-3 bg-white" onClick={onAccount} data-testid="shop-loyalty-signup">{pts ? "Cadastre-se para ganhar e trocar pontos" : "Cadastre-se para usar seu cashback"}</Button>
      )}
    </div>
  );
}

export function ShopHero({ st, color, onInfo, me, onAccount }) {
  const oi = openInfo(st);
  return (
    <section className="mx-auto max-w-7xl px-2 pt-3 sm:px-4" data-testid="shop-hero">
      <ShopBanner banners={st.banners || []} color={color} />
      <div className="flex flex-col gap-5 px-2 pb-6 lg:flex-row lg:items-start">
        <div className="flex flex-1 flex-col gap-4 sm:flex-row sm:items-end">
          <div className="relative z-10 -mt-14 ml-2 h-28 w-28 shrink-0 overflow-hidden rounded-2xl border-4 border-white shadow-lg sm:-mt-20 sm:ml-6 sm:h-44 sm:w-44" style={{ background: color }}>
            {st.logo_url ? <img src={imgUrl(st.logo_url)} alt="Logo" className="h-full w-full object-cover" data-testid="shop-logo" />
              : <span className="grid h-full w-full place-items-center text-4xl font-extrabold text-white sm:text-6xl" data-testid="shop-logo-initials">{st.name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase()}</span>}
          </div>
          <div className="min-w-0 sm:pb-2">
            <h1 className="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl" data-testid="shop-store-name">{st.name}</h1>
            <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm sm:text-base">
              <span className={oi.open ? "font-semibold text-emerald-600" : "font-semibold text-red-500"} data-testid="shop-open-status">{oi.text}</span>
              {st.city && <><span className="text-slate-400">•</span><span className="flex items-center gap-1 text-slate-600"><MapPin className="h-4 w-4" />{st.city}</span></>}
              <span className="text-slate-400">•</span>
              <button onClick={onInfo} className="font-semibold text-slate-700 hover:underline" data-testid="shop-more-info-btn">Mais informações</button>
            </div>
            {!st.accepting && <p className="mt-2 text-sm text-slate-500">Você pode ver o cardápio; os pedidos abrem no horário de funcionamento.</p>}
          </div>
        </div>
        {st.loyalty?.enabled && <div className="lg:pt-5"><LoyaltyCard l={st.loyalty} me={me} onAccount={onAccount} color={color} /></div>}
      </div>
    </section>
  );
}
